export enum AuthModalComponentEnum {
    LOGIN = 'logIn',
    SIGNUP = 'signUp',
    RESET_PASSWORD = 'resetPassword'
}

export type AuthModalComponentEnumValue = `${AuthModalComponentEnum}`;